<template>
  <div>
    <b-overlay
      :show="countriesResponses('countriesList')"
      spinner-type="border"
      variant="light"
      spinner-variant="primary"
      opacity="1"
      rounded>
      <div class="d-flex align-items-end pt-2 pb-6">
        <div class="d-flex flex-column">
          <h1 class="h5 mb-2">
            Countries
          </h1>
          <b-breadcrumb class="breadcrumb-transparent breadcrumb-line p-0 m-0">
            <b-breadcrumb-item :to="{ name: 'Dashboard' }">
              <i class="fa fa-home fa-sm mr-2"></i>
              Home
            </b-breadcrumb-item>
            <b-breadcrumb-item active>Settings</b-breadcrumb-item>
            <b-breadcrumb-item active>Countries</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>

      <b-card
        no-body
        class="card-custom card-border">

        <b-card-body>
          <table
            class="table mb-0"
            :class="{ 'table-hover' : !countriesEmpty }">
            <thead>
              <tr>
                <th
                  v-for="field in fields"
                  :key="field.title"
                  scope="col"
                  :class="[field.classnames]"
                  :width="field.width">
                  {{ field.title }}
                </th>
              </tr>
            </thead>
            <tbody v-if="!countriesEmpty">
              <tr
                v-for="(country, index) in countriesList"
                :key="`country-${index}`">
                <th
                  scope="row"
                  class="pl-5">
                  <span class="small font-weight-light">{{ index + 1 }}</span>
                </th>
                <td>
                  <img
                    :src="countryFlag(country.code)"
                    :alt="country.flag"
                    class="w-20px mr-3 no-select rounded-sm bg-light border border-light" />
                  <span class="font-weight-bold">{{ countryName(country.code) }}</span>
                </td>
                <td class="pr-5 text-right">
                  <span class="text-uppercase">{{ country.code }}</span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td :colspan="fields.length">
                  <no-data-found />
                </td>
              </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { GET_COUNTRIES } from '@/core/services/store/countries.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { toastOptions } from '@/main'

export default {
  name: 'SettingsCountries',
  data() {
    return {
      fields: [
        {
          title: '#',
          classnames: ['pl-5'],
          width: '50px',
        },
        {
          title: 'Country',
        },
        {
          title: 'ISO 2',
          classnames: ['text-right', 'pr-5'],
          width: '100px',
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'countriesList',
      'countriesEmpty',
      'totalCountries',
      'countryFlag',
      'countryName',
      'countriesResponses',
    ]),
  },
  created() {
    this.$store.dispatch(GET_COUNTRIES)
    
    eventBus.$on('showToast/SettingsCountries', ({ message, variant }) => {
      this.showToast(message, variant)
    })
  },
  destroyed() {
    eventBus.$off('showToast/SettingsCountries')
  },
  methods: {
    showToast(message, variant) {
      this.$bvToast.toast(message, {
        variant: variant,
        ...toastOptions
      })
    }
  },
}
</script>
